'use client'

import MyGames from 'pageContainers/MyGames/Games'
import { useAppSelector } from 'src/store/hooks'
import { playedSlotsSelector, playedGamesLayoutSelector } from 'store/modules/playedGames/selectors'

import t from '../../../utils/getTranslationClient'

export default function Slots() {
  const games = useAppSelector(playedSlotsSelector)
  const layout = useAppSelector(playedGamesLayoutSelector)

  return <MyGames games={games} gameType='slot' title={t('my_slot_games')} dataTestId='game-tiles-container' layout={layout} />
}
